export enum ForexReportTypes {
  API_SUCCESS = "@@forex_data/API_SUCCESS",
  API_ERROR = "@@forex_data/API_ERROR",
  GET_REPORT_DATA = "@@forex_data/GET_REPORT_DATA",
  GET_CONSULTANT = "@@forex_data/GET_CONSULTANT",
}
